<template>
  <div id="app">
    <header>
      cc-absence importer
    </header>
    <div class="container">
      <CollectorComponent v-if="step === 0"></CollectorComponent>
    </div>
  </div>
</template>

<script>
import CollectorComponent from './components/CollectorComponent.vue';

export default {
  name: 'app',
  components: {
    CollectorComponent,
  },
  data() {
    return {
      step: 0,
    };
  },
};
</script>

<style lang="scss">
html, body {
  margin: 0;
  padding: 0;
}
.container {
  max-width: 500px;
  margin: 0 auto;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  header {
    font-size: 2.2rem;
    font-weight: bold;
    text-align: center;
    color: #ffffff;
    background-color: #2c3e50;
    padding: 1rem;
    margin-bottom: 2rem;
  }
}
</style>
